import moment from "moment";
export class AbstractSchedule {
    constructor(amount, unit, store) {
        this._nextRun = moment();
        this._interval = { amount: 356, unit: "d" };
        this.getState = () => {
            return this._store.getState();
        };
        this.getNextRun = () => {
            return this._nextRun;
        };
        this._interval.amount = amount;
        this._interval.unit = unit;
        this._store = store;
    }
    setNextRun() {
        this._nextRun = moment().add(this._interval.amount, this._interval.unit);
    }
    isReady() {
        if (this._nextRun.isSameOrBefore(moment())) {
            return true;
        }
        return false;
    }
}
